import { receiveChatStream, type ChatStreamOptions } from "@/utils/chat_stream";
import type { DefaultApi, EvaluationChatRequest } from "@/api";
import { EvaluationChat } from "@/models/evaluation_chat";
import { EvaluationChats } from "@/models/evaluation_chats";
import type { State as RootState } from "@/stores";
import type { Module } from "vuex";
export interface State {
  evaluationChats?: EvaluationChats;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    evaluationChats: undefined,
  },
  actions: {
    async getEvaluationChat(
      { commit },
      {
        positionId,
        evaluationId,
      }: {
        positionId: number;
        evaluationId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getEvaluationChat(evaluationId, positionId);
      const chats = new EvaluationChats(
        response.data.map(
          (chat: Partial<EvaluationChat>) => new EvaluationChat(chat),
        ),
      );
      commit("setEvaluationChats", chats);
      return chats;
    },
    async postEvaluationChat(
      { commit },
      {
        positionId,
        evaluationId,
        chatRequest,
        onText,
        onError,
        signal,
      }: {
        positionId: number;
        evaluationId: number;
        chatRequest: EvaluationChatRequest;
      } & ChatStreamOptions,
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const data = await receiveChatStream<EvaluationChat[]>(
        (options) =>
          api.postEvaluationChat(
            positionId,
            evaluationId,
            chatRequest,
            options,
          ),
        { onText, onError, signal },
      );
      const chats = new EvaluationChats(
        data.map((chat: Partial<EvaluationChat>) => new EvaluationChat(chat)),
      );
      commit("appendEvaluationChats", chats);
      return chats;
    },
  },
  mutations: {
    setEvaluationChats(state, chats: EvaluationChats) {
      state.evaluationChats = chats;
    },
    appendEvaluationChats(state, chats: EvaluationChats) {
      if (state.evaluationChats === undefined) state.evaluationChats = chats;
      else state.evaluationChats = [...state.evaluationChats, ...chats];
    },
  },
};
